import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/util";

const DOT = { Rubis: "#B3122F", Saphir: "#1F4E9E", "Émeraude": "#138A5B" };
const num = (c) => parseFloat(String(c).replace(",", "."));

export const StoneSizes = ({ p, opts }) => {
  const [items, setItems] = useState([]);
  const c = p.custom;
  useEffect(() => { api.get("/custom/catalog").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  const cur = items.find((i) => i.slug === p.slug);
  if (!c?.central || !cur) return null;
  const gems = ["Rubis", "Saphir", "Émeraude"];
  const same = items.filter((i) => i.design === cur.design && i.kind === c.kind && i.shape === c.shape && i.central);
  const bySize = new Map();
  same.forEach((i) => { const key = cur.gem ? i.gem : i.central; const k = bySize.get(key); if (!k || i.slug === p.slug) bySize.set(key, i); });
  const sizes = [...bySize.values()].sort((a, b) => cur.gem ? gems.indexOf(a.gem) - gems.indexOf(b.gem) : num(a.central) - num(b.central));
  if (sizes.length < 2) return null;
  const qs = new URLSearchParams(opts).toString();
  return (
    <div data-testid="stone-sizes">
      <p className="eyebrow mb-2">{cur.gem ? "Pierre précieuse" : "Taille de la pierre"} : <span className="text-black">{cur.gem ? `${cur.gem} · ` : ""}{c.central} ct</span></p>
      <div className="flex flex-wrap gap-2">
        {sizes.map((i) => <Link key={i.slug} to={`/produit/${i.slug}?${qs}`} data-testid={`stone-size-${i.central}`} aria-current={i.slug === p.slug} className={`min-w-12 px-4 h-12 inline-flex items-center border text-sm transition-colors ${i.slug === p.slug ? "bg-black text-white border-black" : "hover:border-black"}`}>{i.gem && <span className="w-4 h-4 rounded-full mr-2 shrink-0 ring-1 ring-black/20" style={{ background: `radial-gradient(circle at 30% 30%, #fff8 0, transparent 40%), ${DOT[i.gem]}` }} data-testid={`gem-dot-${i.gem}`} />}{i.gem ? `${i.gem} · ` : ""}{i.central} ct</Link>)}
      </div>
    </div>
  );
};
